import React, {useEffect, useContext} from "react";
import {withBreadcrumbs} from "../../common/hoc/Breadcrumbs";
import {Card, CardBody, Col, FormGroup} from "reactstrap";
import {useGlobalConfigApi} from "../../../lib/api/globalConfig";
import SwitchExtraButton from "./SwitchExtraButton";
import {t} from "i18next";
import ElementWithAccessInCountries from "../../../lib/utils/hocs/ElementWithAccessInCountries";
import {GlobalSettingsState} from "../../../lib/api/globalSettingsProvider"
import InsuranceTooltip from "../../generic/tooltips/InsuranceTooltip";
import InfoTooltip from "../../generic/InfoTooltip";

const Separate = withBreadcrumbs((props) => {
    const {getGlobalSettings, saveGlobalSettings} = useGlobalConfigApi('global-settings');
    const {globalSettings, setGlobalSettings} = useContext(GlobalSettingsState);

    useEffect(() => {
        getGlobalSettings().then((data) => {
            setGlobalSettings(data.config);
        })
    }, [])

    const onChange = (key, value) => {
        const valueObj = { ...globalSettings };

        if (key === 'partial_payment_available' || key === 'installment_available') {
            valueObj.partial_payment_available = false;
            valueObj.installment_available = false;
        }

        valueObj[key] = value;

        saveGlobalSettings(valueObj).then(() => {
            setGlobalSettings(valueObj);
        })
    }

    return (
        <Card body className='mb-2'>
            <CardBody>
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                    <Col>
                        <FormGroup>
                            <SwitchExtraButton
                                value={globalSettings.installment_available}
                                setValue={value => onChange('installment_available', value)}
                                id='installment_available'
                                label={t('globalSettings.separateFunctionality.enableInstallment')}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <div className="d-flex align-items-center">
                                <SwitchExtraButton
                                    value={globalSettings.tbank_two_step_payment}
                                    setValue={value => onChange('tbank_two_step_payment', value)}
                                    id='tbank_two_step_payment'
                                    label={t('globalSettings.separateFunctionality.enableTbankTwoStepPayment')}
                                />
                                <InfoTooltip text={t('globalSettings.separateFunctionality.enableTwoStepPaymentInfo')}/>
                            </div>
                        </FormGroup>
                    </Col>
                </ElementWithAccessInCountries>
                <Col>
                    <FormGroup>
                        <SwitchExtraButton
                            value={globalSettings.insurance_available}
                            setValue={value => onChange('insurance_available', value)}
                            id='insurance_available'
                            label={t('globalSettings.separateFunctionality.enableCustomerInsurance')}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <div class="d-flex align-items-center">
                            <SwitchExtraButton
                                value={globalSettings.insurance_available_sport}
                                setValue={value => onChange('insurance_available_sport', value)}
                                id='insurance_available_sport' disabled={!globalSettings.insurance_available}
                                label={t('globalSettings.separateFunctionality.enableCustomerInsuranceSport')}
                            />
                            <InsuranceTooltip type="sport"/>
                        </div>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <div className="d-flex align-items-center">
                            <SwitchExtraButton
                                value={globalSettings.insurance_available_adventure}
                                setValue={value => onChange('insurance_available_adventure', value)}
                                id='insurance_available_adventure' disabled={!globalSettings.insurance_available}
                                label={t('globalSettings.separateFunctionality.enableCustomerInsuranceAdventure')}
                            />
                            <InsuranceTooltip type="adventure"/>
                        </div>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <SwitchExtraButton
                            value={globalSettings.promo_subscription_available}
                            setValue={value => onChange('promo_subscription_available', value)}
                            id='promo_subscription_available'
                            label={t('management.promoCodes.useForAbonements')}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <SwitchExtraButton
                            value={globalSettings.partial_payment_available}
                            setValue={value => onChange('partial_payment_available', value)}
                            id='partial_payment_available'
                            label={t('globalSettings.separateFunctionality.enablePartialPayment')}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <SwitchExtraButton
                            value={globalSettings.m3_two_step_payment}
                            setValue={value => onChange('m3_two_step_payment', value)}
                            id='m3_two_step_payment'
                            label={t('globalSettings.separateFunctionality.enableM3TwoStepPayment')}
                        />
                    </FormGroup>
                </Col>
            </CardBody>
        </Card>

    )
})

export default Separate;